export enum OperationTypes{
    Edit = 'Edit',
    Add = 'Add',
    View = 'View'
}